import { Compass, Loader2 } from "lucide-react";
import { fmtDist, fmtSugestao } from "./descobertaHelpers";

const MSG = {
  sem_cidade: "Informe a cidade da empresa (card “Cidade dos bairros”) para sugerir a região automaticamente.",
  sem_centro: "Não foi possível localizar o centro da cidade no OpenStreetMap.",
  not_found: "Bairro não encontrado no OpenStreetMap — escolha a região manualmente.",
  error: "OpenStreetMap indisponível no momento — escolha a região manualmente.",
};

// Linha de status abaixo do select de Região: "Sugerida: Zona Norte · 3,4 km do centro" ou o motivo de não haver sugestão.
export function RegiaoSugestaoHint({ sugestao, aplicada, testId = "regiao-sugestao-hint" }) {
  const { status, data, loading } = sugestao || {};
  if (loading) {
    return <p className="text-[11px] text-muted-foreground mt-1 flex items-center gap-1" data-testid={testId} data-status="loading"><Loader2 className="w-3 h-3 animate-spin" />Localizando bairro no OpenStreetMap…</p>;
  }
  if (!status || status === "idle") return null;
  if (status === "ok") {
    const s = data?.sugestao;
    if (!s?.regiao_id) {
      return <p className="text-[11px] text-amber-700 mt-1" data-testid={testId} data-status="sem-regiao">Fica na {s?.zona_label || "zona"} ({fmtSugestao(s)}), mas não há região cadastrada com esse nome.</p>;
    }
    return (
      <p className={`text-[11px] mt-1 flex items-center gap-1 ${aplicada ? "text-emerald-700" : "text-muted-foreground"}`} data-testid={testId} data-status="ok" data-regiao-id={s.regiao_id}>
        <Compass className="w-3 h-3" />{aplicada ? "Sugerida" : "Sugestão"}: <b>{s.regiao_nome}</b>{s.regiao_nome !== s.zona_label ? ` (${s.zona_label})` : ""} · {fmtDist(s)}
      </p>
    );
  }
  return <p className="text-[11px] text-muted-foreground mt-1" data-testid={testId} data-status={status}>{MSG[status] || MSG.error}</p>;
}
